import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { WhiteLabelService } from 'src/app/_service/white-label.service';

@Component({
  selector: 'app-offline',
  templateUrl: './offline.component.html',
  styleUrls: ['./offline.component.css']
})
export class OfflineComponent implements OnInit {

  constructor(
    private router: Router,
    private whitelabelService: WhiteLabelService
  ) { }

  ngOnInit(): void {
  
  }

  openDownloads(){
    const route = this.whitelabelService.getPrefixedRoute('downloads');
    this.router.navigate([route]);
  }
}
